<template>
  <div
    class="rating flex my-auto space-x-1"
    :class="{ disabled }"
    @mouseleave="modelValue === 0 ? (current = 0) : (current = modelValue)"
  >
    <div v-for="i in [1, 2, 3, 4, 5]" class="relative cursor-pointer my-auto">
      <IconStarHalfFilled
        class="text-nami-nami-blue"
        v-if="current === i - 0.5"
      />
      <IconStarFilled class="text-nami-nami-blue" v-else-if="current >= i" />
      <IconStar v-else-if="current < i" />
      <!-- <div class="absolute left-0 top-0 w-1/2 h-full" @mouseenter="current = i - 0.5" @click="update(i - 0.5)"></div>
      <div class="absolute left-1/2 top-0 w-1/2 h-full" @mouseenter="current = i" @click="update(i)"></div> -->
      <div
        class="absolute left-0 top-0 w-full h-full"
        @mouseenter="current = i"
        @click="update(i)"
      ></div>
    </div>
    <div class="rating__extra" v-if="!noClear">
      <NamiButton
        v-if="modelValue > 0"
        buttonType="danger"
        text
        :icon="IconX"
        small
        @buttonClick="update(0)"
      >
        Clear
      </NamiButton>
      <!-- <p class="my-auto">
        {{ current <= 1 ? 'Terrible' : current <= 2 ? 'Bad' : current <= 3 ? 'Okay' : current <= 4 ? 'Great' : 'Masterpiece' }}
      </p> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  IconStar,
  IconStarFilled,
  IconStarHalfFilled,
  IconX,
} from "@tabler/icons-vue";
import NamiButton from "../nami/NamiButton.vue";

interface Props {
  modelValue: number;
  disabled?: boolean;
  noClear?: boolean;
}

interface Events {
  (e: "update:modelValue", v: number): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Events>();

const current = ref(props.modelValue);

function update(value: number) {
  current.value = value;
  emit("update:modelValue", value);
}
</script>

<style scoped>
.rating__extra {
  @apply hidden;
}
.rating:hover .rating__extra {
  @apply flex !ml-2 space-x-2;
}
</style>
